import { useTranslation } from "react-i18next";
import GenericDialog from "./generic";
import { JsonViewer } from "widgets/shared/jsonViewer";

const AuditTrailDialog = (props: {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  jsonData: {};
}) => {
  const { isOpen, onClose, onSuccess, jsonData } = props;
  const { t } = useTranslation();

  return (
    <GenericDialog
      isOpen={isOpen}
      title={t("dialog.audit.trail.title")}
      onOk={onClose}
      onExit={onClose}
    >
      <div className="flex w-full max-h-[400px] p-4 justify-center overflow-y-auto">
        <JsonViewer data={jsonData} />
      </div>
    </GenericDialog>
  );
};

export default AuditTrailDialog;
  